import { useLang } from "@/context/LanguageContext";
import BrandMarkWatermark from "@/components/BrandMarkWatermark";

const ABOUT_IMG = "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80";

export default function About() {
  const { t } = useLang();
  const pillars = [t.about.pillar_1, t.about.pillar_2, t.about.pillar_3, t.about.pillar_4];

  return (
    <section id="about" className="relative section-y bg-[color:var(--bone)] overflow-hidden" data-testid="about-section">
      <BrandMarkWatermark size={780} opacity={0.10} style={{ top: 40, left: -80, zIndex: 1 }} />
      <div className="container-lux">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left column — copy */}
          <div className="lg:col-span-7">
            <div className="overline" data-testid="about-overline">{t.about.overline}</div>
            <h2
              className="mt-6 font-serif-display text-[clamp(2rem,4.5vw,3.75rem)] leading-[1.05] tracking-[-0.01em] text-[color:var(--anthracite)]"
              data-testid="about-title"
            >
              {t.about.title}
            </h2>

            <figure className="mt-10 border-s-2 border-[color:var(--copper)] ps-6 py-2 max-w-2xl">
              <blockquote className="font-serif-display italic text-[22px] leading-[1.45] text-[color:var(--anthracite)]/90">
                “{t.about.quote}”
              </blockquote>
            </figure>

            <div className="mt-10 space-y-6 max-w-2xl">
              <p className="text-[16px] leading-[1.8] text-[color:var(--anthracite)]/75" data-testid="about-body-1">
                {t.about.body_1}
              </p>
              <p className="text-[16px] leading-[1.8] text-[color:var(--anthracite)]/75" data-testid="about-body-2">
                {t.about.body_2}
              </p>
            </div>
          </div>

          {/* Right column — image */}
          <div className="lg:col-span-5">
            <div className="relative aspect-[3/4] overflow-hidden bg-[color:var(--alabaster)]">
              <img
                src={ABOUT_IMG}
                alt="Luxury interior"
                className="img-cover"
                loading="lazy"
              />
            </div>
            <div className="mt-4 text-[11px] tracking-[0.22em] uppercase text-[color:var(--anthracite)]/50">
              Esentepe · Şişli · İstanbul
            </div>
          </div>
        </div>

        {/* Pillars */}
        <div className="mt-24 border-t border-[color:var(--line)] pt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {pillars.map((p, i) => (
            <div key={p.title} className="relative" data-testid={`about-pillar-${i}`}>
              <div className="font-serif-display text-[42px] text-[color:var(--copper)]/60">0{i + 1}</div>
              <h3 className="mt-4 font-serif-display text-[24px] text-[color:var(--anthracite)] leading-tight">
                {p.title}
              </h3>
              <p className="mt-3 text-[14.5px] leading-[1.7] text-[color:var(--anthracite)]/70">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
